import { render, staticRenderFns } from "./CRMCutomerBaseInfo.vue?vue&type=template&id=0ec9046b&scoped=true&"
import script from "./CRMCutomerBaseInfo.vue?vue&type=script&lang=js&"
export * from "./CRMCutomerBaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./CRMCutomerBaseInfo.vue?vue&type=style&index=0&id=0ec9046b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec9046b",
  null
  
)

export default component.exports